var $ = jQuery.noConflict();

(function() {


	/* Sticky Description script based on 
	/**
	 * Sticky Sidebar v2 JavaScript Plugin.
	 * @version 1.0.1
	 * @author Øystein Blixhavn <oystein@blixhavn.no>
	 * @license The MIT License (MIT)
	 */

	// Prevent multiple initializations
	if(window.sgProductFixedInitialized) {
		console.log('[sg-fixed] already initialized, skipping...');
		return;
	}
	window.sgProductFixedInitialized = true;

	// MINIMUM VIEWPORT WIDTH - below this, all functionality is disabled
	//var MIN_VIEWPORT_WIDTH = 1200;
	var MIN_VIEWPORT_WIDTH = 1024;
	
	// HEIGHT CALCULATION METHOD
	// true = use parent container height directly (simpler, for floated layouts)
	// false = iterate through children to find max bottom (more precise, handles complex layouts)
	var USE_PARENT_HEIGHT_METHOD = true;

	// Safety utility functions
	function safeNumber(val, defaultVal) {
		defaultVal = defaultVal || 0;
		if(typeof val !== 'number' || isNaN(val) || !isFinite(val)) {
			return defaultVal;
		}
		if(Math.abs(val) > 50000) {
			console.warn('[sg-fixed] value exceeded safe limit:', val);
			return defaultVal;
		}
		return val;
	}

	function isElementValid($el) {
		return $el && $el.length > 0 && $el.is(':visible');
	}

	function safeGetHeight($el) {
		try {
			if(!isElementValid($el)) return 0;
			var height = $el.outerHeight(true);
			return safeNumber(height, 0);
		} catch(e) {
			return 0;
		}
	}

	function safeGetOffset($el) {
		try {
			if(!isElementValid($el)) return { top: 0, left: 0 };
			var offset = $el.offset();
			return {
				top: safeNumber(offset ? offset.top : 0, 0),
				left: safeNumber(offset ? offset.left : 0, 0)
			};
		} catch(e) {
			return { top: 0, left: 0 };
		}
	}

	// Wait for full page load before initializing
	$(window).on('load', function(){
		console.log('[sg-fixed] page fully loaded, initializing...');
		try {
			initSgProductFixed();
		} catch(e) {
			console.error('[sg-fixed] initialization error:', e);
		}
	});

	function initSgProductFixed() {
		// DOM elements
		var $desc = $('.productView-description');
		var $inner = $('.productView-description-inner');
		var $inner2 = $('.productView-description-inner2');
		var $left = $('.halo-productView-left');
		var $topDiv = $('.productView-top > div');
		
		// State
		var storedDescHeight = null;
		var affixedType = 'STATIC';
		var direction = 'down';
		var lastScrollTop = 0;
		var currentTranslateY = 0;
		var isInitialized = false;
		var _running = false; // Prevent multiple simultaneous updates
		
		var dimensions = {
			containerTop: 0,
			containerHeight: 0,
			containerBottom: 0,
			inner2Height: 0,
			inner2Width: 0,
			viewportHeight: 0,
			viewportTop: 0,
			topSpacing: 0,
			bottomSpacing: 0,
			maxTranslateY: 0
		};

		// ==========================================
		// RESET - Clear all styles (for < 1024px)
		// ==========================================
		function resetAll() {
			storedDescHeight = null;
			affixedType = 'STATIC';
			isInitialized = false;
			
			if($desc.length) {
				$desc.css({ height: '', overflow: '' });
			}
			if($inner.length) {
				$inner.css({ height: '', position: '', overflow: '' });
			}
			if($inner2.length) {
				$inner2.css({
					position: '',
					top: '',
					left: '',
					bottom: '',
					width: '',
					transform: '',
					right: '',
					visibility: '',
					opacity: '',
					zIndex: '',
					display: ''
				});
			}
			
			// Disconnect observers on mobile to prevent queued callbacks triggering on resize
			disconnectObservers();
			
			console.log('[sg-fixed] resetAll - viewport < ' + MIN_VIEWPORT_WIDTH + 'px');
		}

		// ==========================================
		// MASTER FUNCTION - Single entry point
		// ==========================================
		function runProductFixed(forceRecalc) {
			// var viewportWidth = safeNumber($(window).width(), 0);
			var viewportWidth = window.innerWidth || 0;
			
			// CHECK WIDTH FIRST - if below minimum, reset and exit
			if(viewportWidth < MIN_VIEWPORT_WIDTH) {
				resetAll();
				return;
			}
			
			// Width is >= 1024, run all functionality
			// Reconnect observers if they were disconnected (switching from mobile to desktop)
			setupObservers();
			
			try {
				applyDescHeightDiff(forceRecalc);
				
				// Force reflow after setting height to ensure dimensions are accurate
				if($desc[0]) $desc[0].offsetHeight;
				
				// If forcing recalc (resize, DOM change, or initial load), reset sticky state
				// This prevents bad translateY values when user has scrolled before init
				if(forceRecalc) {
					currentTranslateY = 0;
					affixedType = 'STATIC';
					// Apply STATIC style first to reset any bad positioning
					applyStyle('STATIC');
					
					// Force another reflow after applying STATIC to ensure clean state
					if($inner2[0]) $inner2[0].offsetHeight;
				}
				
				// Recalculate dimensions with updated container height
				calcDimensions();
				console.log('[sg-fixed] After recalc dimensions:', {
					containerHeight: dimensions.containerHeight,
					containerTop: dimensions.containerTop,
					containerBottom: dimensions.containerBottom,
					inner2Height: dimensions.inner2Height,
					maxTranslateY: dimensions.maxTranslateY
				});
				
				updateSticky();
				updateDescBottomVisibility();
			} catch(e) {
				console.warn('[sg-fixed] runProductFixed error:', e);
			}
		}

		// ==========================================
		// HEIGHT DIFF CALCULATION
		// ==========================================
		
		// Helper function to get element's document offset using offsetTop chain
		// This is more reliable than getBoundingClientRect when user has scrolled
		function getDocumentOffsetTop(el) {
			var top = 0;
			while(el) {
				top += el.offsetTop || 0;
				el = el.offsetParent;
			}
			return top;
		}
		
		function applyDescHeightDiff(forceRecalc) {
			if(!$left.length || !$topDiv.length || !$desc.length) return;
			
			// If we have a stored height and not forcing recalc, use it
			if(storedDescHeight !== null && !forceRecalc) {
				$desc.css('height', storedDescHeight);
				return;
			}
			
			// Clear styles before measuring
			$desc.css('height', '');
			if($inner.length) {
				$inner.css({ height: '', position: '' });
			}
			if($inner2.length) {
				$inner2.css({
					position: '',
					top: '',
					left: '',
					bottom: '',
					width: '',
					transform: ''
				});
			}
			
			// Force reflow on parent
			if($topDiv[0]) $topDiv[0].offsetHeight;
			
			var otherMaxH = 0;
			
			if(USE_PARENT_HEIGHT_METHOD) {
				// SIMPLE METHOD: Use parent container height directly
				// This works well for floated layouts where container expands to fit all children
				var topDivHeight = safeGetHeight($topDiv);
				otherMaxH = topDivHeight;
				console.log('[sg-fixed] Parent height method: topDivHeight =', topDivHeight);
			} else {
				// CHILDREN METHOD: Iterate through children to find max bottom
				// This is more precise for complex layouts
				var topDivOffset = $topDiv.offset();
				var topDivTop = topDivOffset ? topDivOffset.top : 0;
				var otherMaxBottom = 0;
				var otherElements = [];
				
				$topDiv.children().each(function() {
					var $child = $(this);
					// Skip left column and description
					if($child.hasClass('halo-productView-left') || $child.hasClass('productView-description')) {
						return; // continue
					}
					
					// Use jQuery offset and outerHeight - these are document-relative
					// and not affected by scroll position
					var childOffset = $child.offset();
					var childTop = childOffset ? childOffset.top : 0;
					var childHeight = $child.outerHeight(true) || 0;
					var childBottom = childTop + childHeight;
					
					var childInfo = { 
						el: $child[0].className || $child[0].tagName, 
						height: childHeight,
						top: childTop,
						bottom: childBottom
					};
					otherElements.push(childInfo);
					if(childBottom > otherMaxBottom) {
						otherMaxBottom = childBottom;
					}
				});
				
				// Calculate relative to topDiv top
				otherMaxH = otherMaxBottom - topDivTop;
				console.log('[sg-fixed] Children method: elements =', otherElements, 'maxBottom:', otherMaxBottom, 'topDivTop:', topDivTop, 'otherMaxH:', otherMaxH);
			}
			
			var leftH = safeGetHeight($left);      // Left image wrapper height
			var descNaturalH = safeGetHeight($desc); // Description natural height (without fixed height)
			var leftTotalH = leftH + descNaturalH;   // Total left column: images + description
			
			console.log('[sg-fixed] height check:', { 
				otherElementsMax: otherMaxH, 
				leftImages: leftH, 
				descNatural: descNaturalH, 
				leftTotal: leftTotalH 
			});
			
			// CHECK: If left column (images + description) is >= other elements max, DON'T apply script
			// The left column is already tall enough, no need to extend
			if(leftTotalH >= otherMaxH) {
				console.log('[sg-fixed] Left column >= other elements, NOT applying fixed script');
				storedDescHeight = null;
				isInitialized = false;
				return;
			}
			
			// Left column is SHORTER than other elements - calculate how much to extend
			var diff = safeNumber(otherMaxH - leftH, 0);
			
			console.log('[sg-fixed] Left shorter than right, extending by:', diff);
			
			// Apply height if reasonable (increased max to 10000 to handle Globo/complementary products)
			if(diff > 100 && diff < 10000) {
				storedDescHeight = diff;
				originalMinHeight = diff; // Store as original minimum
				$desc.css('height', diff);
				isInitialized = true;
				console.log('[sg-fixed] Set originalMinHeight:', originalMinHeight);
			} else {
				console.log('[sg-fixed] Diff outside acceptable range (100-10000):', diff);
				storedDescHeight = null;
			}
		}

		// ==========================================
		// STICKY FUNCTIONALITY
		// ==========================================
		function calcDimensions() {
			if(!$desc.length || !$inner2.length) return;
			
			var dims = dimensions;
			var containerOffset = safeGetOffset($desc);
			dims.containerTop = containerOffset.top;
			dims.containerHeight = safeGetHeight($desc);
			dims.containerBottom = dims.containerTop + dims.containerHeight;
			dims.inner2Height = safeGetHeight($inner2);
			dims.inner2Width = safeNumber($desc.width(), 0);
			dims.viewportHeight = safeNumber($(window).height(), 800);
			dims.viewportTop = safeNumber($(window).scrollTop(), 0);
			dims.maxTranslateY = safeNumber(dims.containerHeight - dims.inner2Height, 0);
		}

		function observeScrollDir() {
			var dims = dimensions;
			dims.viewportTop = safeNumber($(window).scrollTop(), 0);
			if(dims.viewportTop === lastScrollTop) return;
			var furthest = direction === 'down' ? Math.min : Math.max;
			if(dims.viewportTop === furthest(dims.viewportTop, lastScrollTop)) {
				direction = direction === 'down' ? 'up' : 'down';
			}
		}

		function isFitsViewport() {
			var dims = dimensions;
			return dims.viewportHeight >= (dims.inner2Height + dims.topSpacing + dims.bottomSpacing);
		}

		function getAffixType() {
			var dims = dimensions;
			dims.viewportTop = safeNumber($(window).scrollTop(), 0);
			
			var colliderTop = dims.viewportTop + dims.topSpacing;
			var colliderBottom = dims.viewportTop + dims.viewportHeight - dims.bottomSpacing;
			var newAffixType = affixedType;
			
			if(colliderTop <= dims.containerTop || dims.containerHeight <= dims.inner2Height) {
				currentTranslateY = 0;
				newAffixType = 'STATIC';
			} else {
				newAffixType = (direction === 'up') ? 
					getAffixTypeScrollingUp(colliderTop, colliderBottom) : 
					getAffixTypeScrollingDown(colliderTop, colliderBottom);
			}
			
			currentTranslateY = safeNumber(Math.max(0, currentTranslateY), 0);
			currentTranslateY = Math.min(dims.containerHeight, currentTranslateY);
			currentTranslateY = Math.round(currentTranslateY);
			
			lastScrollTop = dims.viewportTop;
			return newAffixType;
		}

		function getAffixTypeScrollingDown(colliderTop, colliderBottom) {
			var dims = dimensions;
			var inner2Bottom = dims.inner2Height + dims.containerTop;
			var newAffixType = affixedType;
			
			if(isFitsViewport()) {
				if(dims.inner2Height + colliderTop >= dims.containerBottom) {
					currentTranslateY = dims.containerBottom - inner2Bottom;
					newAffixType = 'CONTAINER-BOTTOM';
				} else if(colliderTop >= dims.containerTop) {
					currentTranslateY = colliderTop - dims.containerTop;
					newAffixType = 'VIEWPORT-TOP';
				}
			} else {
				if(dims.containerBottom <= colliderBottom) {
					currentTranslateY = dims.containerBottom - inner2Bottom;
					newAffixType = 'CONTAINER-BOTTOM';
				} else if(inner2Bottom + currentTranslateY <= colliderBottom) {
					currentTranslateY = colliderBottom - inner2Bottom;
					newAffixType = 'VIEWPORT-BOTTOM';
				} else if(dims.containerTop + currentTranslateY <= colliderTop &&
					(currentTranslateY !== 0 && dims.maxTranslateY !== currentTranslateY)) {
					newAffixType = 'VIEWPORT-UNBOTTOM';
				}
			}
			return newAffixType;
		}

		function getAffixTypeScrollingUp(colliderTop, colliderBottom) {
			var dims = dimensions;
			var inner2Bottom = dims.inner2Height + dims.containerTop;
			var newAffixType = affixedType;
			
			if(colliderTop <= currentTranslateY + dims.containerTop) {
				currentTranslateY = colliderTop - dims.containerTop;
				newAffixType = 'VIEWPORT-TOP';
			} else if(dims.containerBottom <= colliderBottom) {
				currentTranslateY = dims.containerBottom - inner2Bottom;
				newAffixType = 'CONTAINER-BOTTOM';
			} else if(!isFitsViewport()) {
				if(dims.containerTop <= colliderTop &&
					(currentTranslateY !== 0 && dims.maxTranslateY !== currentTranslateY)) {
					newAffixType = 'VIEWPORT-UNBOTTOM';
				}
			}
			return newAffixType;
		}

		function applyStyle(type) {
			if(!type || !$inner2.length) return;
			
			var dims = dimensions;
			var containerOffset = safeGetOffset($desc);
			var viewportLeft = safeNumber($(window).scrollLeft(), 0);
			var innerStyle = {};
			var outerStyle = {};
			
			switch(type) {
				case 'VIEWPORT-TOP':
					innerStyle = {
						position: 'fixed',
						top: dims.topSpacing + 'px',
						left: (containerOffset.left - viewportLeft) + 'px',
						width: dims.inner2Width + 'px',
						bottom: 'auto',
						transform: '',
						right: 'auto',
						visibility: 'visible',
						opacity: 1,
						zIndex: 10,
						display: 'block'
					};
					outerStyle = { height: dims.inner2Height + 'px', position: 'relative', overflow: 'visible' };
					break;
					
				case 'VIEWPORT-BOTTOM':
					innerStyle = {
						position: 'fixed',
						top: 'auto',
						left: (containerOffset.left - viewportLeft) + 'px',
						bottom: dims.bottomSpacing + 'px',
						width: dims.inner2Width + 'px',
						transform: '',
						right: 'auto',
						visibility: 'visible',
						opacity: 1,
						zIndex: 10,
						display: 'block'
					};
					outerStyle = { height: dims.inner2Height + 'px', position: 'relative', overflow: 'visible' };
					break;
					
				case 'CONTAINER-BOTTOM':
				case 'VIEWPORT-UNBOTTOM':
					innerStyle = {
						position: 'absolute',
						top: currentTranslateY + 'px',
						left: '0px',
						width: dims.inner2Width + 'px',
						bottom: 'auto',
						transform: '',
						right: 'auto',
						visibility: 'visible',
						opacity: 1,
						zIndex: 10,
						display: 'block'
					};
					outerStyle = { height: dims.inner2Height + 'px', position: 'relative', overflow: 'visible' };
					break;
					
				case 'STATIC':
				default:
					innerStyle = {
						position: 'relative',
						top: '',
						left: '',
						bottom: '',
						width: '',
						transform: '',
						right: '',
						visibility: '',
						opacity: '',
						zIndex: '',
						display: ''
					};
					outerStyle = { height: '', position: '', overflow: '' };
					break;
			}
			
			$inner2.css(innerStyle);
			if($inner.length) $inner.css(outerStyle);
			if($desc.length) $desc.css({ overflow: 'visible' });
		}

		function updateSticky() {
			if(!$desc.length || !$inner2.length || !isInitialized) return;
			
			calcDimensions();
			
			if(dimensions.containerHeight <= 0 || dimensions.inner2Height <= 0) {
				return;
			}
			
			observeScrollDir();
			var newAffixType = getAffixType();
			applyStyle(newAffixType);
			affixedType = newAffixType;
		}

		// ==========================================
		// VISIBILITY CLASS
		// ==========================================
		function updateDescBottomVisibility() {
			if(!$desc.length) return;
			var descOffset = safeGetOffset($desc);
			var descBottom = descOffset.top + safeGetHeight($desc);
			var viewportBottom = safeNumber($(window).scrollTop(), 0) + safeNumber($(window).height(), 800);
			if (viewportBottom >= (descBottom - 80)) {
				$desc.addClass('fixed-scroll-desc');
			} else {
				$desc.removeClass('fixed-scroll-desc');
			}
		}

		// ==========================================
		// OBSERVERS
		// ==========================================
		var observerTimer = null;
		var observer = null;
		var resizeObserver = null;
		var contentResizeObserver = null; // For inner2 content changes (tabs, accordions)
		var isRecalculating = false;
		var lastTopDivHeight = 0; // Track height to prevent unnecessary recalcs
		var lastInner2Height = 0; // Track inner2 height for content changes
		var observersActive = false; // Track if observers are currently connected

		// Disconnect all observers (for mobile viewport)
		function disconnectObservers() {
			if(!observersActive) return;
			
			clearTimeout(observerTimer);
			
			if(observer) {
				observer.disconnect();
			}
			if(resizeObserver) {
				resizeObserver.disconnect();
			}
			if(contentResizeObserver) {
				contentResizeObserver.disconnect();
			}
			
			observersActive = false;
			console.log('[sg-fixed] Observers disconnected (mobile viewport)');
		}

		function setupObservers() {
			// Skip if already active
			if(observersActive) return;
			var productTop = document.querySelector('.productView-top');
			var topDivElement = $topDiv[0];
			var inner2Element = $inner2[0];
			
			// -------- MutationObserver (for DOM changes) --------
			if(productTop && typeof MutationObserver !== 'undefined') {
				if(observer) observer.disconnect();
				
				observer = new MutationObserver(function(mutations){
					if(isRecalculating) return;
					
					var hasRelevantChange = mutations.some(function(mutation) {
						return mutation.type === 'childList' && 
						       (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
					});
					
					if(!hasRelevantChange) return;
					
					clearTimeout(observerTimer);
					observerTimer = setTimeout(function(){
						console.log('[sg-fixed] DOM changed (childList) -> recalculating');
						triggerRecalc();
					}, 150);
				});
				
				observer.observe(productTop, { childList: true, subtree: true, attributes: false });
			}
			
			// -------- ResizeObserver on topDiv (for Globo and similar) --------
			if(topDivElement && typeof ResizeObserver !== 'undefined') {
				if(resizeObserver) resizeObserver.disconnect();
				
				// Store initial height
				lastTopDivHeight = topDivElement.offsetHeight || 0;
				
				resizeObserver = new ResizeObserver(function(entries){
					if(isRecalculating) return;
					
					// Check if height actually changed significantly (more than 50px)
					var newHeight = entries[0] ? entries[0].contentRect.height : 0;
					var heightDiff = Math.abs(newHeight - lastTopDivHeight);
					
					if(heightDiff < 50) return; // Ignore small changes
					
					console.log('[sg-fixed] ResizeObserver (topDiv): height changed', lastTopDivHeight, '->', newHeight, '(diff:', heightDiff, ')');
					lastTopDivHeight = newHeight;
					
					clearTimeout(observerTimer);
					observerTimer = setTimeout(function(){
						triggerRecalc();
					}, 150);
				});
				
				resizeObserver.observe(topDivElement);
			}
			
			// -------- ResizeObserver on inner2 (for tab/accordion content changes) --------
			if(inner2Element && typeof ResizeObserver !== 'undefined') {
				if(contentResizeObserver) contentResizeObserver.disconnect();
				
				// Store initial height
				lastInner2Height = inner2Element.scrollHeight || 0;
				
				contentResizeObserver = new ResizeObserver(function(entries){
					if(isRecalculating) return;
					
					// Use scrollHeight to get full content height
					var newHeight = inner2Element.scrollHeight || 0;
					var heightDiff = Math.abs(newHeight - lastInner2Height);
					
					if(heightDiff < 30) return; // Ignore small changes (threshold lower for tabs)
					
					console.log('[sg-fixed] ResizeObserver (inner2 content): height changed', lastInner2Height, '->', newHeight, '(diff:', heightDiff, ')');
					lastInner2Height = newHeight;
					
					// For content changes, just update sticky (don't recalc container height)
					clearTimeout(observerTimer);
					observerTimer = setTimeout(function(){
						updateStickyAfterContentChange();
					}, 100);
				});
				
				contentResizeObserver.observe(inner2Element);
			}
			
			// -------- Tab click listener (backup for tab switches) --------
			$(document).on('click.sgProductFixed', '.productView-description .tab-title, .productView-description .toggleLink', function(){
				console.log('[sg-fixed] Tab/toggle clicked -> updating sticky');
				clearTimeout(observerTimer);
				observerTimer = setTimeout(function(){
					updateStickyAfterContentChange();
				}, 200); // Delay to let CSS transitions complete
			});
			
			observersActive = true;
			console.log('[sg-fixed] Observers connected (desktop viewport)');
		}
		
		// Store the original minimum height (calculated diff)
		var originalMinHeight = null;
		
		// Update sticky after content change (tabs/accordions)
		function updateStickyAfterContentChange() {
			// Check viewport width first - skip on small screens
			var viewportWidth = window.innerWidth || 0;
			if(viewportWidth < MIN_VIEWPORT_WIDTH) {
				console.log('[sg-fixed] updateStickyAfterContentChange skipped - viewport < ' + MIN_VIEWPORT_WIDTH + 'px');
				return;
			}
			
			if(isRecalculating) return;
			
			isRecalculating = true;
			
			// Get the new inner2 content height
			var newInner2Height = $inner2[0] ? $inner2[0].scrollHeight || safeGetHeight($inner2) : 0;
			var currentContainerHeight = storedDescHeight || safeGetHeight($desc);
			
			// Recalculate current minimum based on other elements (they may have changed)
			var currentOtherMaxH = 0;
			$topDiv.children().each(function() {
				var $child = $(this);
				if($child.hasClass('halo-productView-left') || $child.hasClass('productView-description')) {
					return; // continue
				}
				var childH = safeGetHeight($child);
				if(childH > currentOtherMaxH) {
					currentOtherMaxH = childH;
				}
			});
			var leftH = safeGetHeight($left);
			var currentMinRequired = safeNumber(currentOtherMaxH - leftH, 0);
			
			// Update original minimum if current requirement is higher
			if(currentMinRequired > originalMinHeight) {
				console.log('[sg-fixed] Updating minimum height:', originalMinHeight, '->', currentMinRequired);
				originalMinHeight = currentMinRequired;
			}
			
			console.log('[sg-fixed] Content change check:', { 
				newInner2Height: newInner2Height, 
				currentContainerHeight: currentContainerHeight,
				currentOtherMaxH: currentOtherMaxH,
				leftH: leftH,
				currentMinRequired: currentMinRequired,
				originalMinHeight: originalMinHeight
			});
			
			// Determine new height: max of content height and minimum required
			var newHeight = Math.max(newInner2Height, originalMinHeight || 0);
			
			// Apply if changed
			if(Math.abs(newHeight - currentContainerHeight) > 1) { // Threshold to avoid floating point issues
				console.log('[sg-fixed] Adjusting container height:', currentContainerHeight, '->', newHeight);
				storedDescHeight = newHeight;
				$desc.css('height', newHeight);
			}
			
			// Recalculate dimensions with updated container height
			calcDimensions();
			
			// Update sticky position
			if(isInitialized && dimensions.containerHeight > 0 && dimensions.inner2Height > 0) {
				observeScrollDir();
				var newAffixType = getAffixType();
				applyStyle(newAffixType);
				affixedType = newAffixType;
			}
			
			// Update stored height
			if($inner2[0]) {
				lastInner2Height = $inner2[0].scrollHeight || 0;
			}
			
			console.log('[sg-fixed] Sticky updated after content change');
			
			setTimeout(function() { 
				isRecalculating = false; 
			}, 200);
		}
		
		// Centralized recalc function with guards
		function triggerRecalc() {
			// Check viewport width first - skip on small screens
			var viewportWidth = window.innerWidth || 0;
			if(viewportWidth < MIN_VIEWPORT_WIDTH) {
				console.log('[sg-fixed] triggerRecalc skipped - viewport < ' + MIN_VIEWPORT_WIDTH + 'px');
				return;
			}
			
			if(isRecalculating) return;
			
			// IMPORTANT: Check if heights actually changed BEFORE clearing styles
			// This prevents unnecessary recalcs that cause scroll jumps
			if($topDiv[0] && lastTopDivHeight > 0) {
				var currentTopDivHeight = $topDiv[0].offsetHeight || 0;
				var heightDiff = Math.abs(currentTopDivHeight - lastTopDivHeight);
				
				// If height changed by less than 50px, skip the full recalc
				if(heightDiff < 50) {
					console.log('[sg-fixed] triggerRecalc skipped - no significant height change (diff:', heightDiff, ')');
					return;
				}
				
				console.log('[sg-fixed] triggerRecalc proceeding - height changed:', lastTopDivHeight, '->', currentTopDivHeight, '(diff:', heightDiff, ')');
			}
			
			isRecalculating = true;
			runProductFixed(true);
			
			// Update stored height after recalc
			var heightAfterRecalc = 0;
			if($topDiv[0]) {
				heightAfterRecalc = $topDiv[0].offsetHeight || 0;
				lastTopDivHeight = heightAfterRecalc;
			}
			
			// Reset flag after delay and check for async content changes
			setTimeout(function() { 
				isRecalculating = false;
				
				// Re-check height after recalculating period - catches async loading content
				// (like complementary products that load via fetch after DOM is ready)
				if($topDiv[0]) {
					var currentHeight = $topDiv[0].offsetHeight || 0;
					var heightDiff = Math.abs(currentHeight - heightAfterRecalc);
					
					if(heightDiff > 50) {
						console.log('[sg-fixed] Async content detected after recalc, height changed:', heightAfterRecalc, '->', currentHeight, '(diff:', heightDiff, ')');
						// Schedule another recalc for the async content
						clearTimeout(observerTimer);
						observerTimer = setTimeout(function(){
							triggerRecalc();
						}, 100);
					}
				}
			}, 300);
			
			// Also schedule a second check after 600ms for slower async content
			setTimeout(function() {
				if(isRecalculating) return;
				
				if($topDiv[0]) {
					var currentHeight = $topDiv[0].offsetHeight || 0;
					var heightDiff = Math.abs(currentHeight - lastTopDivHeight);
					
					if(heightDiff > 50) {
						console.log('[sg-fixed] Late async content detected, height changed:', lastTopDivHeight, '->', currentHeight, '(diff:', heightDiff, ')');
						triggerRecalc();
					}
				}
			}, 600);
		}

		// ==========================================
		// EVENT HANDLERS
		// ==========================================
		
		// Run Scripts after Window Resize
		/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
		var rtime;
		var timeout = false;
		var delta = 100;
		$(window).resize(function() {
			rtime = new Date();
			if (timeout === false) {
				timeout = true;
				setTimeout(resizeend, delta);
			}
		});

		function resizeend() {

		   if (new Date() - rtime < delta) {
				setTimeout(resizeend, delta);
			} else {
				timeout = false;

				runProductFixed(true); // Force recalc on resize

			}

		} // resizeend()

		$(window).on('scroll.sgProductFixed', function(){
			// Prevent multiple simultaneous updates (like sticky-sidebar.js)
			if(_running) return;
			_running = true;
			
			requestAnimationFrame(function(){
				// var viewportWidth = safeNumber($(window).width(), 0);
				var viewportWidth = window.innerWidth || 0;
				if(viewportWidth < MIN_VIEWPORT_WIDTH) {
					_running = false;
					return; // Skip on small viewports
				}
				
				updateSticky();
				updateDescBottomVisibility();
				_running = false;
			});
		});

		// ==========================================
		// INITIALIZATION
		// ==========================================
		window.runProductFixed = runProductFixed;
		
		// Initial run
		runProductFixed(true);
		
		// Setup observers
		setupObservers();
		
		// Viewport checker
		/*try {
			if(typeof $.fn.viewportChecker === 'function') {
				$desc.viewportChecker({    
					classToAdd: 'visible',
					classToAddForFullView: 'full-visible',
					classToRemove: 'invisible',
					removeClassAfterAnimation: false,
					offset: 0,
					invertBottomOffset: true,
					repeat: false
				});
			} else {
				$desc.addClass('visible');
			}
		} catch(e) {
			$desc.addClass('visible');
		}*/

		// Cleanup on page unload
		$(window).on('beforeunload.sgProductFixed', function() {
			if(observer) observer.disconnect();
			if(resizeObserver) resizeObserver.disconnect();
			if(contentResizeObserver) contentResizeObserver.disconnect();
			$(document).off('click.sgProductFixed');
			clearTimeout(observerTimer);
		});

	} // end initSgProductFixed

})(); // IIFE
